export const OIL_AND_FILTER_CHANGE = 'OIL_AND_FILTER_CHANGE';
export const BRAKE_INSPECTION_AND_REPLACEMENT =
    'BRAKE_INSPECTION_AND_REPLACEMENT';
export const BATTERY_CHECK = 'BATTERY_CHECK';
export const FILTERS_REPLACEMENT = 'FILTERS_REPLACEMENT';
export const FLUIDS_CHECK = 'FLUIDS_CHECK';
export const WHEEL_ALIGNMENT_AND_BALANCING = 'WHEEL_ALIGNMENT_AND_BALANCING';
export const TIRE_INSPECTION = 'TIRE_INSPECTION';
export const TUNE_UP = 'TUNE_UP';
export const AIR_CONDITIONING_SERVICE = 'AIR_CONDITIONING_SERVICE';
export const GENERAL_INSPECTION = 'GENERAL_INSPECTION';

export const DEFAULT_SERVICE_DETAILS = [
    OIL_AND_FILTER_CHANGE,
    BRAKE_INSPECTION_AND_REPLACEMENT,
    BATTERY_CHECK,
    FILTERS_REPLACEMENT,
    FLUIDS_CHECK,
    WHEEL_ALIGNMENT_AND_BALANCING,
    TIRE_INSPECTION,
    TUNE_UP,
    AIR_CONDITIONING_SERVICE,
    GENERAL_INSPECTION,
];
